export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const SET_USER = 'SET_USER';
export const LOGOUT = 'LOGOUT';

export const CONSOLE_USERS_HISTORY = 'CONSOLE_USERS_HISTORY';
export const USERS_HISTORY = 'USERS_HISTORY';
export const LOGIN_HISTORY = 'LOGIN_HISTORY';
export const USER_LOGIN_HISTORY = 'USER_LOGIN_HISTORY';

export const FLIGHT_METHODS = 'FLIGHT_METHODS';
export const FLIGHT_PRIORITIES = 'FLIGHT_PRIORITIES';
export const FLIGHT_STATUSES = 'FLIGHT_STATUSES';
export const FLIGHT_CUSTOM_PARAMETERS = 'FLIGHT_CUSTOM_PARAMETERS';
export const FLIGHTS_LIST = 'FLIGHTS_LIST';
export const CLEAR_FLIGHTS_LIST = 'CLEAR_FLIGHTS_LIST';
export const FLIGHT_DETAILS = 'FLIGHT_DETAILS';
export const REMOVE_FLIGHT_DETAILS = 'REMOVE_FLIGHT_DETAILS';
export const CREATE_NEW_FLIGHT_SUCCESS = 'CREATE_NEW_FLIGHT_SUCCESS';
export const CREATE_NEW_FLIGHT_FAIL = 'CREATE_NEW_FLIGHT_FAIL';
export const UPDATE_FLIGHT_STATUS_SUCCESS = 'UPDATE_FLIGHT_STATUS_SUCCESS';
export const UPDATE_FLIGHT_DETAILS_SUCCESS = 'UPDATE_FLIGHT_DETAILS_SUCCESS';
export const GET_DOOSRA_CASH_TRANSACTIONS_SUCCESS = 'GET_DOOSRA_CASH_TRANSACTIONS_SUCCESS';
export const GET_DOOSRA_CASH_TRANSACTIONS_FAIL = 'GET_DOOSRA_CASH_TRANSACTIONS_FAIL';
export const CLEAR_DOOSRA_CASH_TRANSACTIONS_LIST = 'CLEAR_DOOSRA_CASH_TRANSACTIONS_LIST';

export const GET_TRANSACTION_DETAILS = 'GET_TRANSACTION_DETAILS';
export const CLEAR_TRANSACTION_DETAILS = 'CLEAR_TRANSACTION_DETAILS';

export const CONSOLE_USERS_SUGGESTION = 'CONSOLE_USERS_SUGGESTION';
export const USERS_SUGGESTION = 'USERS_SUGGESTION';
export const FIELDS_ERROR = 'FIELDS_ERROR';

export const TWO_FA_CREATE = '2FA_CREATE';
export const TWO_FA_VERIFY = '2FA_VERIFY';
export const TWO_FA_VALIDATE = '2FA_VALIDATE';
export const TWO_FA_SEND_OTP = '2FA_SEND_OTP';
export const TWO_FA_VERIFY_OTP = '2FA_VERIFY_OTP';
export const RESET_STATE = 'RESET_STATE';
export const NETWORK_ERROR = 'NETWORK_ERROR';

export const SEND_OTP = 'SEND_OTP';
export const VERIFY_OTP = 'VERIFY_OTP';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const ERROR = 'ERROR';
export const ADMIN_PORTAL = 'ADMIN PORTAL';
